import { Uris } from "../common/constants";
import { BaseService } from "./base.service";

type attributType = 'equipment' | 'document' | 'vehicule'

export interface IAttributeService {
  getAttributes: (params:{type:attributType}) => Promise<any>;
}

export class AttributeService extends BaseService implements IAttributeService {
  getAttributes(params:{type:attributType}): Promise<any>{
    return super.get(Uris.Attribute,params)
  }
}



// WEBPACK FOOTER //
// ./src/services/attribute.service.ts